import { Checkbox, TableCell, TableHead, TableRow } from "@mui/material";
import TableHeaderCell from "./TableHeaderCell";
import CreateButton from "../CreateButton";


function TableHeaderDynamic({ columns, sortColumn, sortDirection, onSort, numSelected, rowCount, onSelectAllClick, canCreate, entity }) {
  return (
    <TableHead>
      <TableRow>
        {onSelectAllClick && rowCount > 0 &&
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all answers',
              }}
            />
          </TableCell>
        }
        {columns.map((column) => (
          <TableHeaderCell
            key={column.id}
            column={column}
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            onSort={onSort} />
        ))}
        <TableCell align="center">
          {canCreate && <CreateButton entity={entity} />}
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default TableHeaderDynamic